

export const professions = [
  "ACCOMPAGNATEUR (hors montagne)",
  "ACCOMPAGNATEUR EN BASSE / MOYENNE MONTAGNE",
  "ACCOMPAGNATEUR EN HAUTE MONTAGNE (guide de haute montagne)",
  "ACHETEUR",
  "ACOUSTICIEN",
  "ACROBATE DE CIRQUE",
  "ACTEUR",
  "ACTUAIRE",
  "ACUPUNCTEUR",
  "ADJOINT ADMINISTRATIF",
  "ADJOINT TECHNIQUE",
  "ADJOINT TECHNIQUE TERRITORIAL",
  "ADMINISTRATEUR DE BIENS",
  "ADMINISTRATEUR DE DONNEES",
  "ADMINISTRATEUR SYSTEME",
  "ADMINISTRATEUR TERRITORIAL",
  "ADMINISTRATEUR DES VENTES",
  "AFFRETEUR",
  "AFFUTEUR",
  "AGENT ADMINISTRATIF",
  "AGENT COMMERCIAL",
  "AGENT D’ASSURANCE",
  "AGENT D'ACCOMPAGNEMENT",
  "AGENT D'ACCUEIL",
  "AGENT DE CHANGE",
  "AGENT DE FABRICATION",
  "AGENT DE LA POSTE",
  "AGENT DE MAINTENANCE",
  "AGENT DE MAITRISE",
  "AGENT DE POLICE FERROVIAIRE",
  "AGENT DE PREVENTION",
  "AGENT DE PRODUCTION",
  "AGENT DE PROPRETE",
  "AGENT DE PUBLICITE",
  "AGENT DE QUALITE",
  "AGENT DE RECOUVREMENT",
  "AGENT DE RESTAURATION",
  "AGENT DE SECURITE (avec port d'armes)",
  "AGENT DE SECURITE (sans port d'armes)",
  "AGENT DE SERVICE",
  "AGENT DE SURETE (avec port d'armes)",
  "AGENT DE SURETE (sans port d'armes)",
  "AGENT DE SURVEILLANCE (avec port d'armes)",
  "AGENT DE SURVEILLANCE (sans port d'armes)",
  "AGENT DE TRAITEMENT DECHETS (avec manipulation de produit dangereux)",
  "AGENT DE TRAITEMENT DECHETS (sans manipulation de produit dangereux)",
  "AGENT DE VOYAGES",
  "AGENT DE CONTROLE DES TRANSPORTS",
  "AGENT D'ESCALE FERROVIAIRE",
  "AGENT D'ENTRETIEN",
  "AGENT DES DOUANES",
  "AGENT D'EXPLOITATION",
  "AGENT GENERAL",
  "AGENT HOSPITALIER",
  "AGENT IMMOBILIER",
  "AGENT LOGISTIQUE",
  "AGENT MAGASINIER",
  "AGENT POLYVALENT",
  "AGENT TECHNIQUE",
  "AGRICULTEUR",
  "AIDE A DOMICILE",
  "AIDE AUX PERSONNES AGEES",
  "AIDE FAMILIALE",
  "AIDE MEDICO-PSYCHOLOGIQUE",
  "AIDE MENAGERE",
  "AIDE SOIGNANT",
  "AIGUILLEUR DE RAIL",
  "AJUSTEUR",
  "ALESEUR",
  "ALLERGOLOGUE",
  "AMBASSADEUR",
  "AMBULANCIER",
  "ANALYSTE FINANCIER",
  "ANALYSTE INFORMATIQUE",
  "ANDROLOGUE",
  "ANESTHESISTE",
  "ANGIOLOGUE",
  "ANIMATEUR DE FORMATION",
  "ANIMATEUR DE SCENE TV ET RADIO",
  "ANTIQUAIRE",
  "APICULTEUR",
  "AQUACULTEUR",
  "ARBITRE PROFESSIONNEL",
  "ARBORICULTEUR",
  "ARCHEOLOGUE",
  "ARCHITECTE",
  "ARCHIVISTE",
  "ARDOISIER",
  "ARMURIER",
  "ARTIFICIER",
  "ARTISTE PEINTRE",
  "ARTISTE SCULPTEUR",
  "ARTISTE LYRIQUE",
  "ASCENSORISTE",
  "ASSISTANT",
  "ASSISTANT ADMINISTRATIF",
  "ASSISTANT CHEF DE PRODUIT",
  "ASSISTANT COMMERCIAL",
  "ASSISTANT COMPTABLE",
  "ASSISTANT DE DIRECTION",
  "ASSISTANT DE GESTION",
  "ASSISTANT DENTAIRE",
  "ASSISTANT DU SON",
  "ASSISTANT JURIDIQUE",
  "ASSISTANT MARKETING",
  "ASSISTANT MATERNEL",
  "ASSISTANT MEDICAL",
  "ASSISTANT RESSOURCES HUMAINES",
  "ASSISTANT SOCIAL",
  "ASSISTANT VETERINAIRE",
  "ASTROLOGUE",
  "ASTRONOME",
  "ASTROPHYSICIEN",
  "ATSEM",
  "ATTACHE COMMERCIAL",
  "ATTACHE D'AMBASSADE",
  "ATTACHE DE DIRECTION",
  "ATTACHE DE PRESSE",
  "ATTACHE TERRITORIAL",
  "AUDIOLOGISTE",
  "AUDIOPROTHESISTE",
  "AUDITEUR",
  "AUTEUR",
  "AUXILIAIRE DE PUERICULTURE",
  "AUXILIAIRE DE VIE",
  "AVICULTEUR",
  "AVOCAT",
  "BAGAGISTE",
  "BANQUIER",
  "BARBIER",
  "BARDEUR",
  "BARMAN",
  "BATELIER",
  "BETONNEUR",
  "BIBLIOTHECAIRE",
  "BIJOUTIER",
  "BIOLOGISTE (avec manipulation de produits dangereux)",
  "BIOLOGISTE (sans manipulation de produits dangereux)",
  "BITUMEUR",
  "BLANCHISSEUR",
  "BOTANISTE",
  "BOUCHER",
  "BOULANGER",
  "BRANCARDIER",
  "BRIQUETEUR",
  "BROCANTEUR",
  "BUCHERON",
  "BURALISTE",
  "CABLEUR",
  "CADREUR",
  "CAFETIER",
  "CAISSIER",
  "CALORIFUGEUR",
  "CAMERAMAN CINEMA/TELEVISION",
  "CANCEROLOGUE/ONCOLOGUE",
  "CANTONNIER",
  "CAPITAINE DE MARINE MARCHANDE",
  "CARDIOLOGUE",
  "CARISTE",
  "CARRELEUR",
  "CARRIER",
  "CARROSSIER-PEINTRE",
  "CARTOMANCIEN",
  "CASCADEUR",
  "CATENAIRISTE",
  "CAVISTE",
  "CERAMISTE",
  "CHANTEUR",
  "CHARCUTIER",
  "CHARGE D'AFFAIRE",
  "CHARGE DE CLIENTELE",
  "CHARGE DE COMMUNICATION",
  "CHARGE DE MISSION",
  "CHARGE DE RECRUTEMENT",
  "CHARGE DE RELATIONS PUBLIQUES",
  "CHARGE D'ETUDE",
  "CHARPENTIER",
  "CHASSEUR",
  "CHAUDRONNIER",
  "CHAUFFAGISTE",
  "CHAUFFEUR",
  "CHAUFFEUR LIVREUR",
  "CHAUFFEUR ROUTIER POIDS LOURDS (sans transport de produits dangereux)",
  "CHAUFFEUR ROUTIER POIDS LOURDS (avec transport de produits dangereux)",
  "CHAUFFEUR TAXI",
  "CHEF COMPTABLE",
  "CHEF CUISINIER",
  "CHEF D'ORCHESTRE",
  "CHEF DE CABINE (compagnie reguliere)",
  "CHEF DE CABINE (compagnie non reguliere)",
  "CHEF DE CHANTIER",
  "CHEF DE FABRICATION",
  "CHEF DE PRODUIT",
  "CHEF DE PROJET",
  "CHEF DE PUBLICITE",
  "CHEF DE RANG",
  "CHEF DE RAYON",
  "CHEF DE SALLE",
  "CHEF DE SECTEUR",
  "CHEF DE SERVICE (hors tertiaire)",
  "CHEF DE SERVICE (tertiaire)",
  "CHEF DE VENTE",
  "CHEF D'ENTREPRISE (MOINS DE 5 SALARIES)",
  "CHEF D'ENTREPRISE (5 SALARIES ET PLUS)",
  "CHEF D'EQUIPE",
  "CHEF D'EXPLOITATION AGRICOLE",
  "CHEF OPERATEUR",
  "CHERCHEUR (avec manipulation de produits dangereux)",
  "CHERCHEUR (sans manipulation de produits dangereux)",
  "CHIMISTE (avec manipulation de produits dangereux)",
  "CHIMISTE (sans manipulation de produits dangereux)",
  "CHIROPRACTEUR",
  "CHIRURGIEN",
  "CHIRURGIEN DENTISTE",
  "CHOCOLATIER",
  "CHOREGRAPHE",
  "CHORISTE",
  "CHRISTOLOGUE",
  "CIMENTIER",
  "CISELEUR",
  "CLERC DE NOTAIRE",
  "COACH NON SPORTIF",
  "COACH SPORTIF",
  "COIFFEUR",
  "COLLABORATEUR PARLEMENTAIRE",
  "COMEDIEN",
  "COMMANDANT MARINE MARCHANDE",
  "COMMERCANT ALIMENTATION",
  "COMMERCANT BRICOLAGE",
  "COMMERCANT EPICERIE",
  "COMMERCANT HABILLEMENT",
  "COMMERCANT QUINCAILLERIE",
  "COMMERCANT TEXTILE",
  "COMMERCIAL",
  "COMMIS DE CUISINE",
  "COMMISSAIRE AUX COMPTES",
  "COMMISSAIRE PRISEUR",
  "COMPOSITEUR",
  "COMPTABLE",
  "CONCESSIONNAIRE AUTO/MOTO",
  "CONCIERGE",
  "CONDUCTEUR D'AUTOBUS/ AUTOCAR",
  "CONDUCTEUR DE METRO / TRAMWAY",
  "CONDUCTEUR DE TRAIN",
  "CONDUCTEUR DE TRAVAUX",
  "CONDUCTEUR D'ENGINS",
  "CONDUCTEUR OFFSET",
  "CONFISEUR",
  "CONSEILLER CLIENTELE",
  "CONSEILLER COMMERCIAL",
  "CONSEILLER CONJUGAL",
  "CONSEILLER D'EDUCATION",
  "CONSEILLER D'ORIENTATION",
  "CONSEILLER FINANCIER",
  "CONSTRUCTEUR DE MAISON",
  "CONSULTANT",
  "CONTREMAITRE",
  "CONTROLEUR AERIEN",
  "CONTROLEUR DE GESTION",
  "CONTROLEUR DES IMPOTS",
  "CONTROLEUR FINANCIER",
  "CONTROLEUR QUALITE",
  "CONTROLEUR TECHNIQUE AUTOMOBILE",
  "CONVOYEUR DE FONDS",
  "CORDISTE",
  "CORDONNIER",
  "COSTUMIER SPECTACLE",
  "COURTIER",
  "COUTELIER",
  "COUTURIER HORS SPECTACLE",
  "COUTURIER SPECTACLE",
  "COUVREUR",
  "CREATEUR DE PARFUM / NEZ",
  "CREMIER",
  "CROUPIER",
  "CRS",
  "CRS DE BATEAU",
  "CUISINIER",
  "CUISINISTE",
  "DANSEUR",
  "DANSEUR ETOILE",
  "DEBARDEUR DE BOIS",
  "DEBITEUR DE METAUX",
  "DEBROUSSAILLEUR",
  "DECORATEUR",
  "DELEGUE MEDICAL",
  "DEMANDEUR D’EMPLOI",
  "DEMENAGEUR",
  "DEMINEUR",
  "DENTISTE",
  "DEPANNEUR",
  "DÉPUTÉ",
  "DERATISEUR",
  "DERMATOLOGUE",
  "DESAMIANTEUR",
  "DESIGNER",
  "DESSINATEUR ARTISTIQUE",
  "DESSINATEUR BUREAU D'ETUDE",
  "DESSINATEUR DE MODE",
  "DESSINATEUR INDUSTRIEL",
  "DESSINATEUR PROJETEUR",
  "DETECTIVE",
  "DEVELOPPEUR INFORMATIQUE",
  "DIAGNOSTIQUEUR IMMOBILIER",
  "DIETETICIEN",
  "DIPLOMATE",
  "DIRECTEUR ACHAT",
  "DIRECTEUR ADMINISTRATIF",
  "DIRECTEUR ARTISTIQUE",
  "DIRECTEUR COMMERCIAL",
  "DIRECTEUR COMMUNICATION",
  "DIRECTEUR DE DEVELOPPEMENT",
  "DIRECTEUR DE MAGASIN",
  "DIRECTEUR DE PRODUCTION",
  "DIRECTEUR DE TRAVAUX",
  "DIRECTEUR DES OPERATIONS",
  "DIRECTEUR SYSTEMES INFORMATION",
  "DIRECTEUR D'ETABLISSEMENT",
  "DIRECTEUR EXPORT",
  "DIRECTEUR FINANCIER",
  "DIRECTEUR D'INVESTISSEMENT",
  "DIRECTEUR FISCAL",
  "DIRECTEUR GENERAL",
  "DIRECTEUR JURIDIQUE",
  "DIRECTEUR LOGISTIQUE",
  "DIRECTEUR MARKETING",
  "DIRECTEUR QSE",
  "DIRECTEUR QUALITE",
  "DIRECTEUR REGIONAL",
  "DIRECTEUR RESSOURCES HUMAINES",
  "DIRECTEUR RISK-MANAGEMENT",
  "DIRECTEUR SCIENTIFIQUE AVEC manipulation de produits dangereux",
  "DIRECTEUR SCIENTIFIQUE SANS manipulation de produits dangereux",
  "DIRECTEUR SECURITE (avec port d'armes)",
  "DIRECTEUR SECURITE (sans port d'armes)",
  "DIRECTEUR TECHNIQUE",
  "DIRECTEUR UNITE OPERATIONNELLE",
  "DIRIGEANT DE SOCIETE (MOINS DE 5 SALARIES)",
  "DIRIGEANT DE SOCIETE (5 SALARIES ET PLUS)",
  "DISQUAIRE",
  "DISTILLATEUR D’ALCOOL",
  "DOCKER",
  "DOCUMENTALISTE",
  "DOMPTEUR",
  "DOREUR À LA FEUILLE",
  "DOUANIER",
  "DOUBLEUR DE VOIX",
  "DRAMATURGE",
  "DRESSEUR D’ANIMAUX DOMESTIQUES",
  "DROGUISTE",
  "EBENISTE",
  "EBOUEUR",
  "ECONOMISTE",
  "ECRIVAIN",
  "ECUYER",
  "EDITEUR",
  "EDUCATEUR SOCIAL",
  "EDUCATEUR SPECIALISE",
  "EDUCATEUR SPORTIF",
  "EGOUTIER",
  "ELAGUEUR",
  "ELECTRICIEN",
  "ELECTROMECANICIEN",
  "ELECTRONICIEN",
  "ELEVEUR",
  "EMAILLEUR",
  "EMPAILLEUR",
  "EMPLOYE DE BANQUE",
  "EMPLOYE LIBRE-SERVICE (caisse, mise en rayon, accueil client)",
  "EMPLOYE POMPES FUNEBRES",
  "ENCADREUR",
  "ENDOCRINOLOGUE",
  "ENLUMINEUR",
  "ENSEIGNANT",
  "ENSEIGNANT CHERCHEUR (avec manipulation de produit dangereux)",
  "ENSEIGNANT CHERCHEUR (sans manipulation de produit dangereux)",
  "ENTRAINEUR SPORTIF",
  "EPICIER",
  "EQUARISSEUR",
  "ERGONOME",
  "ERGOTHERAPEUTE",
  "ESTHETICIENNE",
  "ETALAGISTE",
  "ETAMEUR PLOMBIER",
  "ETANCHEUR / ETANCHEISTE",
  "ETHNOLOGUE",
  "ETIOPATHE",
  "ETUDIANT",
  "EXPERT AUTOMOBILE",
  "EXPERT COMPTABLE",
  "EXPERT FINANCIER",
  "EXPERT GESTION",
  "EXPLOITANT AGRICOLE",
  "FACTEUR",
  "FEMME AU FOYER",
  "FEMME DE CHAMBRE",
  "FEMME DE MENAGE",
  "FERRAILLEUR",
  "FERRONNIER",
  "FISCALISTE",
  "FLEURISTE",
  "FONDEUR",
  "FORAIN",
  "FOREUR TRAVAUX PUBLICS",
  "FORGERON",
  "FORMATEUR",
  "FOSSOYEUR",
  "FOURREUR",
  "FRAISEUR",
  "FRIGORISTE",
  "FUMISTE",
  "GALVANISEUR",
  "GARAGISTE",
  "GARÇON DE CAFE",
  "GARDE CHASSE",
  "GARDE COTE",
  "GARDE DU CORPS",
  "GARDE FORESTIER",
  "GARDE PECHE",
  "GARDIEN DE CHENIL",
  "GARDIEN DE LA PAIX",
  "GARDIEN DE MUSEE (avec port d'armes)",
  "GARDIEN DE MUSEE (sans port d'armes)",
  "GARDIEN DE PARCS",
  "GARDIEN DE PHARE",
  "GARDIEN DE PRISON",
  "GARDIEN D'IMMEUBLE",
  "GASTRO ENTEROLOGUE",
  "GEMMOLOGUE",
  "GENDARME",
  "GENEALOGISTE",
  "GEOGRAPHE",
  "GEOLOGUE",
  "GEOMETRE",
  "GEOTECHNIQUE",
  "GERANT DE MAGASIN (MOINS DE 5 SALARIES)",
  "GERANT DE MAGASIN (5 SALARIES ET PLUS)",
  "GERANT DE SOCIETE (MOINS DE 5 SALARIES)",
  "GERANT DE SOCIETE (5 SALARIES ET PLUS)",
  "GERIATRE",
  "GESTIONNAIRE ADMINISTRATIF",
  "GESTIONNAIRE DE STOCK",
  "GESTIONNAIRE DE BIENS",
  "GESTIONNAIRE DE COLLECTION",
  "GESTIONNAIRE DE PAIE",
  "GESTIONNAIRE DE PATRIMOINE",
  "GESTIONNAIRE DE PORTEFEUILLE",
  "GOUDRONNEUR",
  "GOUVERNANTE",
  "GRAINETIER",
  "GRAND REPORTER",
  "GRAPHISTE",
  "GRAVEUR",
  "GRAVEUR D'IMPRIMERIE",
  "GREFFIER",
  "GROSSISTE",
  "GRUTIER",
  "GUICHETIER",
  "GUIDE DE CHASSE",
  "GUIDE DE HAUTE MONTAGNE",
  "GUIDE DE TOURISME",
  "GYNECOLOGUE",
  "HELIOGRAVEUR",
  "HEMATOLOGUE",
  "HEPATOLOGUE",
  "HOMEOPATHE",
  "HOMME GRENOUILLE",
  "HORLOGER",
  "HORTICULTEUR",
  "HOTELIER",
  "HOTESSE AU SOL",
  "HOTESSE D’ACCUEIL",
  "HOTESSE DE CAISSE",
  "HOTESSE DE L'AIR (compagnie non reguliere)",
  "HOTESSE DE L'AIR (compagnie reguliere)",
  "HUISSIER DE JUSTICE",
  "HUMORISTE",
  "HYDROTHERAPEUTE",
  "HYPNOTHERAPEUTE",
  "HYPNOTISEUR",
  "ILLUSTRATEUR",
  "IMPRIMEUR",
  "INFECTIOLOGUE",
  "INFIRMIER/INFIRMIERE",
  "INFOGRAPHISTE",
  "INFORMATICIEN",
  "INGENIEUR COMMERCIAL",
  "INGENIEUR DU SON",
  "INGENIEUR DANS industrie extractive, de raffinage, nucleaire ou armement et AVEC manipulation de produit dangereux",
  "INGENIEUR HORS industrie extractive, de raffinage, nucleaire ou armement et AVEC manipulation de produit dangereux",
  "INGENIEUR DANS industrie extractive, de raffinage, nucleaire ou armement et SANS manipulation de produit dangereux",
  "INGENIEUR HORS industrie extractive, de raffinage, nucleaire ou armement et SANS manipulation de produit dangereux",
  "INSPECTEUR DES IMPOTS",
  "INSPECTEUR DES DOUANES",
  "INSPECTEUR DU TRAVAIL",
  "INSTALLATEUR (LIGNES TELEPHONIQUES)",
  "INSTALLATEUR ANTENNES",
  "INSTALLATEUR D'ALARMES",
  "INSTALLATEUR D'APPAREILS",
  "INSTALLATEUR D'ASCENSEURS",
  "INSTALLATEUR DE CHAUFFAGE",
  "INSTALLATEUR DE CLIMATISATION",
  "INSTALLATEUR SANITAIRE",
  "INSTITUTEUR",
  "INTERMITTENT DU SPECTACLE",
  "INTERNE EN MEDECINE",
  "INTERNISTE",
  "INTERPRETE",
  "ISOLATEUR",
  "JARDINIER",
  "JOAILLIER",
  "JOURNALISTE",
  "JUGE",
  "JURISTE",
  "KINESITHERAPEUTE",
  "LABORANTIN",
  "LAMANEUR",
  "LAMINEUR",
  "LAPIDAIRE",
  "LAVEUR DE CARREAUX ET VITRES",
  "LIBRAIRE",
  "LIGNARD",
  "LIVREUR",
  "LOGISTICIEN",
  "LOTISSEUR",
  "LOUEUR DE VEHICULES",
  "LUTHIER",
  "MAÇON",
  "MAGASINIER",
  "MAGISTRAT",
  "MAGNETISEUR",
  "MAITRE BRASSEUR",
  "MAITRE CHIEN",
  "MAITRE DE BALLET",
  "MAITRE DE CONFERENCE",
  "MAITRE FOREUR TRAVAUX PUBLICS",
  "MAITRE DE MARINE MARCHANDE",
  "MAITRE D'HOTEL",
  "MAITRE D'ŒUVRE",
  "MAITRE NAGEUR",
  "MILITAIRE MAJOR",
  "MANDATAIRE JUDICIAIRE",
  "MANIPULATEUR EN RADIOLOGIE",
  "MANNEQUIN",
  "MANŒUVRE",
  "MANUTENTIONNAIRE",
  "MAQUETTISTE",
  "MARAICHER",
  "MARBRIER",
  "MARCHAND",
  "MARCHAND AMBULANT",
  "MARECHAL FERRANT",
  "MARIONNETTISTE",
  "MARIN PECHEUR",
  "MARKETEUR",
  "MAROQUINIER",
  "MASSEUR",
  "MATHEMATICIEN",
  "MECANICIEN",
  "MEDECIN BIOLOGISTE",
  "MEDECIN DU SPORT",
  "MEDECIN DU TRAVAIL",
  "MEDECIN GENERALISTE",
  "MEDECIN HOSPITALIER",
  "MEDECIN LEGISTE",
  "MEDECIN NEONATAL",
  "MEDECIN NUCLEAIRE",
  "MEDECIN SPECIALISTE",
  "MEDIATEUR",
  "MENUISIER/AGENCEUR",
  "METREUR",
  "MEUNIER",
  "MILITAIRE DU RANG",
  "MINEUR",
  "MINIATURISTE",
  "MINISTRE",
  "MISSIONNAIRE",
  "MONITEUR D'AUTO ECOLE",
  "MONITEUR D'AVIATION",
  "MONITEUR DE CHEVAL",
  "MONITEUR DE PARAPENTE",
  "MONITEUR DE PLONGEE",
  "MONITEUR D'ESCALADE",
  "MONITEUR DE SKI",
  "MONTEUR - ELECTRICIEN",
  "MONTEUR (LIGNES TELEPHONIQUES)",
  "MONTEUR CABLEUR",
  "MONTEUR DE CHAPITEAUX",
  "MONTEUR DE CHARPENTES",
  "MOSAISTE",
  "MUSICIEN",
  "NATUROPATHE",
  "NEGOCIANT",
  "NEPHROLOGUE",
  "NETTOYEUR A SEC",
  "NEURO-CHIRURGIEN",
  "NEUROLOGUE",
  "NOTAIRE",
  "NOTAIRE ASSISTANT",
  "NOURRICE",
  "NUTRITIONNISTE",
  "OBSTETRICIEN",
  "OCEANOGRAPHE",
  "OCULARISTE",
  "ODONTOLOGUE",
  "OENOLOGUE",
  "OFFICIER DE MARINE MARCHANDE",
  "MILITAIRE OFFICIER GENERAL",
  "MILITAIRE OFFICIER MARINIER",
  "MILITAIRE OFFICIER SUBALTERNE",
  "MILITAIRE OFFICIER SUPERIEUR",
  "OPERATEUR DE COMMANDE",
  "OPERATEUR DE DEMOLITION (avec manipulation de produits dangereux)",
  "OPERATEUR DE DEMOLITION (sans manipulation de produits dangereux)",
  "OPERATEUR DE FABRICATION",
  "OPERATEUR DE PRODUCTION",
  "OPERATEUR DE SAISIE",
  "OPERATEUR D'USINAGE DES METAUX",
  "OPHTALMOLOGUE",
  "OPTICIEN",
  "ORFEVRE",
  "ORL",
  "ORTHODONTISTE",
  "ORTHOPEDISTE",
  "ORTHOPHONISTE",
  "ORTHOPROTHESISTE",
  "ORTHOPTISTE",
  "OSTEOPATHE",
  "OSTREICULTEUR",
  "OUVRIER",
  "OUVRIER SPECIALISE DANS industrie extractive, de raffinage, nucleaire ou armement SANS manipulation de produits dangereux",
  "OUVRIER SPECIALISE DANS industrie extractive, de raffinage, nucleaire ou armement AVEC manipulation de produits dangereux",
  "OUVRIER SPECIALISE HORS industrie extractive, de raffinage, nucleaire ou armement SANS manipulation de produits dangereux",
  "OUVRIER SPECIALISE HORS industrie extractive, de raffinage, nucleaire ou armement AVEC manipulation de produits dangereux",
  "OUVRIER DE FORAGE TRAVAUX PUBLICS",
  "PALEFRENIER AVEC MONTE",
  "PALEFRENIER SANS MONTE",
  "PARACHUTISTE",
  "PARAMETREUR",
  "PATISSIER",
  "PAYSAGISTE",
  "PDG",
  "PECHEUR",
  "PECHEUR DE CORAIL",
  "PEDIATRE",
  "PEDICURE",
  "PEINTRE EN BATIMENT",
  "PEPINIERISTE",
  "PERSONNEL D'AMBASSADE",
  "PERSONNEL D'EXECUTION DE MARINE MARCHANDE",
  "PERSONNEL DU CIRQUE",
  "PERSONNEL RELIGIEUX",
  "PHARMACIEN",
  "PHOTOGRAPHE",
  "PHYSICIEN (avec manipulation de produit dangereux)",
  "PHYSICIEN (sans manipulation de produit dangereux)",
  "PILOTE DE LIGNE (compagnie non reguliere)",
  "PILOTE DE LIGNE (compagnie reguliere)",
  "PILOTE HELICOPTERE",
  "PISCICULTEUR",
  "PLANIFICATEUR",
  "PLATRIER/PLAQUISTE",
  "PLOMBEUR ZINGUEUR GALVANISEUR",
  "PLOMBIER",
  "PLOMBIER CHAUFFAGISTE",
  "PLONGEUR",
  "PLONGEUR DE BORD DE MARINE MARCHANDE",
  "PNEUMOLOGUE",
  "PODOLOGUE",
  "POISSONNIER",
  "POLICIER / POLICE SCIENTIFIQUE",
  "POLISSEUR",
  "POMPIER",
  "POMPISTE",
  "POSEUR DE FENETRES",
  "POSEUR DE PARQUETS",
  "POSEUR D'ENSEIGNES",
  "POTIER",
  "PREPARATEUR DE COMMANDES",
  "PREPARATEUR EN PHARMACIE",
  "PRIMEUR",
  "PREFET",
  "PREFET DE POLICE",
  "PROCUREUR",
  "PROFESSEUR",
  "PROGRAMMEUR",
  "PROJETEUR",
  "PROMOTEUR IMMOBILIER",
  "PROTHESISTE DENTAIRE",
  "PROTHESISTE ONGULAIRE",
  "PROTHESISTE ORTHOPEDISTE",
  "PROVISEUR",
  "PSYCHANALISTE",
  "PSYCHIATRE",
  "PSYCHOLOGUE",
  "PSYCHOMOTRICIEN",
  "PUERICULTRICE",
  "PUISATIER",
  "PYROTECHNICIEN",
  "QUINCAILLIER",
  "RABOTEUR",
  "RADIOLOGUE",
  "RAMONEUR",
  "RAVALEUR DE FAÇADE",
  "RAVALEUR RAGREEUR",
  "REALISATEUR",
  "REALISATEUR DE RADIO",
  "RECEPTIONNISTE",
  "REDACTEUR",
  "REFLEXOLOGUE",
  "REGISSEUR",
  "REGULATEUR DE TRAFIC",
  "RELIEUR",
  "REMORQUEUR - DEPANNEUR AUTO",
  "RENTIER",
  "RESPONSABLE ACHAT",
  "RESPONSABLE ADMINISTRATIF",
  "RESPONSABLE ARTISTIQUE",
  "RESPONSABLE DE COLLECTION",
  "RESPONSABLE COMMERCIAL",
  "RESPONSABLE COMMUNICATION",
  "RESPONSABLE COMPTABLE",
  "RESPONSABLE D'AGENCE",
  "RESPONSABLE DE DEVELOPPEMENT",
  "RESPONSABLE D'EXPLOITATION",
  "RESPONSABLE INFORMATIQUE",
  "RESPONSABLE DE MAGASIN",
  "RESPONSABLE DE PRODUCTION",
  "RESPONSABLE DE TRAVAUX",
  "RESPONSABLE DES ETUDES",
  "RESPONSABLE BUREAU D'ETUDE",
  "RESPONSABLE DES OPERATIONS",
  "RESPONSABLE D'ETABLISSEMENT",
  "RESPONSABLE FINANCIER",
  "RESPONSABLE JURIDIQUE",
  "RESPONSABLE LOGISTIQUE",
  "RESPONSABLE MARKETING",
  "RESPONSABLE QUALITE",
  "RESPONSABLE QSE",
  "RESPONSABLE RECOUVREMENT",
  "RESPONSABLE RESSOURCE HUMAINE",
  "RESPONSABLE RISK-MANAGEMENT",
  "RESPONSABLE SECURITE (avec port d'armes)",
  "RESPONSABLE SECURITE (sans port d'armes)",
  "RESPONSABLE TECHNIQUE",
  "RESPONSABLE UNITE OPERATIONNELLE",
  "RESTAURATEUR (GASTRONOMIE)",
  "RESTAURATEUR D'ART",
  "RETOUCHEUR",
  "RETRAITE",
  "RHUMATOLOGUE",
  "SAGE FEMME",
  "SAISONNIER",
  "SANS PROFESSION",
  "SCAPHANDRIER",
  "SCIEUR DE BOIS",
  "SCIEUR DE METAUX",
  "SECRETAIRE",
  "SECRETAIRE GENERAL",
  "SECRETAIRE MEDICALE",
  "SELLIER",
  "SÉNATEUR",
  "SERRURIER",
  "SERTISSEUR",
  "SERVEUR",
  "SOIGNEUR ANIMAUX",
  "SOMMELIER",
  "SONDEUR / FOREUR TRAVAUX PUBLICS",
  "SOPHROLOGUE",
  "SOUDEUR",
  "SOUFFLEUR DE VERRE",
  "SOUS-PREFET",
  "MILITAIRE SOUS OFFICIER",
  "SPORTIF PROFESSIONNEL",
  "STANDARDISTE",
  "STATISTICIEN",
  "STEWART (compagnie non reguliere)",
  "STEWART (compagnie reguliere)",
  "STOMATOLOGUE",
  "STUCATEUR",
  "STYLISTE",
  "SUBSTITUT DU PROCUREUR",
  "SUPERVISEUR (hors tertiaire)",
  "SUPERVISEUR (tertiaire)",
  "SURVEILLANT PENITENTIAIRE",
  "TAILLEUR DE PIERRE",
  "TANNEUR",
  "TAPISSIER",
  "TATOUEUR",
  "TAXI AERIEN",
  "TAXIDERMISTE",
  "TECHNICIEN CHAUFFAGISTE",
  "TECHNICIEN DE LABORATOIRE (avec manipulation de produits dangereux)",
  "TECHNICIEN DE LABORATOIRE (sans manipulation de produits dangereux)",
  "TECHNICIEN DE MAINTENANCE",
  "TECHNICIEN DEPANNEUR",
  "TECHNICIEN ELECTRONIQUE",
  "TECHNICIEN DE FORAGE PETROLE / GAZ",
  "TECHNICIEN DE FORAGE DES TRAVAUX PUBLICS (hors pétrole / gaz)",
  "TECHNICIEN IMAGERIE MEDICALE",
  "TECHNICIEN INFORMATIQUE",
  "TECHNICIEN QUALITE",
  "TECHNICIEN SAV ELECTROMENAGER",
  "TECHNICIEN SUPERIEUR EN INDUSTRIE (AVEC manipulation de produits dangereux)",
  "TECHNICIEN SUPERIEUR EN INDUSTRIE (SANS manipulation de produits dangereux)",
  "TECHNICIEN TELECOMMUNICATION (AVEC POSE DE LIGNES AERIENNES OU SOUTERRAINES)",
  "TECHNICIEN TELECOMMUNICATION (SANS POSE DE LIGNES AERIENNES OU SOUTERRAINES)",
  "TECHNICO-COMMERCIAL",
  "TEINTURIER",
  "TELEVENDEUR",
  "TERRASSIER",
  "THANATOPRACTEUR",
  "TISSERAND",
  "TOILETTEUR D'ANIMAUX",
  "TOLIER",
  "TONNELIER",
  "TOPOGRAPHE",
  "TOURNEUR",
  "TRADER",
  "TRADUCTEUR",
  "TRAITEUR",
  "TRANSPORTEUR (sans transport de produits dangereux)",
  "TRANSPORTEUR (avec transport de produits dangereux)",
  "TRAVAILLEUR FAMILIAL",
  "TRAVAILLEUR SOCIAL",
  "TUEUR D'ABATTOIR",
  "TUILIER",
  "TUYAUTEUR",
  "TYPOGRAPHE",
  "URBANISTE",
  "UROLOGUE",
  "VALET DE CHAMBRE",
  "VEILLEUR DE NUIT (avec port d'arme)",
  "VEILLEUR DE NUIT (sans port d'arme)",
  "VENDEUR",
  "VERNISSEUR BOIS PARQUET",
  "VERRIER EN ARTS PLASTIQUES",
  "VERRIER EN INDUSTRIE",
  "VETERINAIRE",
  "VISITEUR MEDICAL",
  "VITICULTEUR",
  "VITRIER",
  "VITRIFICATEUR DE PARQUETS",
  "VOITURIER",
  "VOYANT",
  "VRP",
  "VULCANOLOGUE",
  "WEBDESIGNER",
  "WEBMASTER",
  "ZINGUEUR"
];


export const professionsInstrumentPrecision = [
    'DENTISTE',
    'CHIRURGIEN-DENTISTE',
    'CHIRURGIEN',
    'NEURO-CHIRURGIEN',
    'ANESTHÉSISTE',
    'MÉDECIN SPÉCIALISTE',
    'PROTHÉSISTE DENTAIRE',
    'HORLOGER',
    'BIJOUTIER',
    'JOAILLIER',
    'LAPIDAIRE',
    'SERTISSEUR',
    'ORFÈVRE',
    'AFFÛTEUR',
    'CISÉLEUR',
    'CORDONNIER',
    'COUTELIER',
    'LUTHIER',
    'PROTHÉSISTE ORTHOPÉDISTE',
    'ORTHOPROTHÉSISTE',
    'SOUDEUR',
    'SOUFFLEUR DE VERRE',
    'TAILLEUR DE PIERRE',
    'EBENISTE',
    'MENUISIER',
    'AGENCEUR',
    'MAQUETTISTE',
    'MAROQUINIER',
    'VERRIER',
    'OCULARISTE',
    'PROTHÉSISTE ONGULAIRE'
  ];

  // Liste des professions nécessitant port de charge
  export const professionsPortCharge = [
    'MAÇON',
    'MANŒUVRE',
    'BARDEUR',
    'CHARPENTIER',
    'MONTEUR DE CHARPENTES',
    'MANUTENTIONNAIRE',
    'DEMENAGEUR',
    'DOCKER',
    'FERRAILLEUR',
    'FERRONNIER',
    'FORGERON',
    'MARBRIER',
    'TAILLEUR DE PIERRE',
    'BUCHERON',
    'SCIEUR DE BOIS',
    'DÉBARDEUR DE BOIS',
    'AGRICULTEUR',
    'EXPLOITANT AGRICOLE'
  ];

  // Liste des professions nécessitant travail en hauteur (à partir de 3m)
  export const professionsTravailHauteur = [
    'ACCOMPAGNATEUR EN HAUTE MONTAGNE',
    'GUIDE DE HAUTE MONTAGNE',
    'ARDOISIER',
    'BARDEUR',
    'CATENAIRISTE',
    'CHARPENTIER',
    'CORDISTE',
    'COUVREUR',
    'ELAGUEUR',
    'ÉTANCHEUR',
    'ÉTANCHEISTE',
    'GRUTIER',
    'INSTALLATEUR ANTENNES',
    'INSTALLATEUR',
    'LIGNES TÉLÉPHONIQUES',
    'LAVEUR DE CARREAUX',
    'LAVEUR DE VITRES',
    'CASCADEUR',
    'ACROBATE DE CIRQUE',
    'MONTEUR',
    'ELECTRICIEN',
    'LIGNARD',
    'MONITEUR D\'ESCALADE',
    'MONITEUR DE PARAPENTE',
    'MONTEUR DE CHAPITEAUX',
    'MONTEUR DE CHARPENTES',
    'PARACHUTISTE',
    'PLOMBEUR',
    'ZINGUEUR',
    'GALVANISEUR',
    'POSEUR D\'ENSEIGNES',
    'RAMONEUR',
    'RAVALEUR DE FAÇADE',
    'RAVALEUR',
    'RAGRÉEUR',
    'TECHNICIEN TÉLÉCOMMUNICATION',
    'MAÇON',
    'PEINTRE EN BATIMENT',
    'VITRIER',
    'POSEUR DE FENETRES',
    'MENUISIER',
    'AGENCEUR',
    'FOREUR TRAVAUX PUBLICS',
    'CAMERAMAN CINEMA',
    'CAMERAMAN TELEVISION',
    'CHEF DE CHANTIER'
  ];

  // Liste des professions à RISQUE GÉNÉRAL (hauteur >20m + autres risques spécifiques)
  export const professionsTravailRisqueGeneral = [
    'ACCOMPAGNATEUR EN HAUTE MONTAGNE',
    'ACROBATE DE CIRQUE',
    'AGENT DE POLICE FERROVIAIRE',
    'AGENT DE SECURITE',
    'AGENT DE SURETE',
    'AGENT DE SURVEILLANCE',
    'AGENT DE TRAITEMENT DECHETS',
    'ARCHEOLOGUE',
    'ARTIFICIER',
    'BIOLOGISTE',
    'CAPITAINE DE MARINE MARCHANDE',
    'CASCADEUR',
    'CATENAIRISTE',
    'CHARPENTIER',
    'CHAUFFEUR ROUTIER POIDS LOURDS',
    'CHIMISTE',
    'COMMANDANT MARINE MARCHANDE',
    'CORDISTE',
    'COUVREUR',
    'DEMINEUR',
    'DIRECTEUR SCIENTIFIQUE',
    'DIRECTEUR SECURITE',
    'EDUCATEUR SPORTIF',
    'ENSEIGNANT CHERCHEUR',
    'ENTRAINEUR SPORTIF',
    'ETANCHEUR',
    'ETANCHEISTE',
    'GARDE DU CORPS',
    'GARDE PECHE',
    'GARDIEN DE MUSEE',
    'GENDARME',
    'GRAND REPORTER',
    'GRUTIER',
    'GUIDE DE HAUTE MONTAGNE',
    'INGENIEUR',
    'INSTALLATEUR',
    'INTERMITTENT DU SPECTACLE',
    'JOURNALISTE',
    'MAITRE DE MARINE MARCHANDE',
    'MILITAIRE',
    'MARIN PECHEUR',
    'MINEUR',
    'MONITEUR D\'AVIATION',
    'MONITEUR DE PARAPENTE',
    'MONITEUR DE PLONGEE',
    'MONITEUR D\'ESCALADE',
    'MONTEUR',
    'ELECTRICIEN',
    'MONTEUR CABLEUR',
    'MONTEUR DE CHAPITEAUX',
    'MONTEUR DE CHARPENTES',
    'OFFICIER DE MARINE MARCHANDE',
    'OPERATEUR DE DEMOLITION',
    'OUVRIER SPECIALISE',
    'PARACHUTISTE',
    'PECHEUR',
    'PECHEUR DE CORAIL',
    'PERSONNEL D\'EXECUTION DE MARINE MARCHANDE',
    'PERSONNEL DU CIRQUE',
    'PHYSICIEN',
    'PILOTE DE LIGNE',
    'PILOTE HELICOPTERE',
    'PLONGEUR',
    'PLONGEUR DE BORD',
    'POLICIER',
    'POLICE SCIENTIFIQUE',
    'POMPIER',
    'PYROTECHNICIEN',
    'RAVALEUR DE FAÇADE',
    'RAVALEUR',
    'RAGRÉEUR',
    'RESPONSABLE SECURITE',
    'SPORTIF PROFESSIONNEL',
    'STEWART',
    'TAXI AERIEN',
    'TECHNICIEN DE LABORATOIRE',
    'TECHNICIEN DE FORAGE',
    'TECHNICIEN SUPERIEUR',
    'TECHNICIEN TELECOMMUNICATION',
    'TRANSPORTEUR',
    'VEILLEUR DE NUIT',
    'VULCANOLOGUE',
    'LIGNARD'
  ];